module.exports = __webpack_public_path__ + "videos/3d-transform_en.5498e64.mp4";